import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueTheMask from 'vue-the-mask'

Vue.prototype.$token = function () {
	if(localStorage.getItem('token')){
		return localStorage.getItem('token')
	}else if(sessionStorage.getItem('token')){ 
		return sessionStorage.getItem('token')
	}else{
		return false
	}
}

Vue.use(VueTheMask)

Vue.config.productionTip = true

new Vue({
	router,
	vuetify,
	render: h => h(App)
}).$mount('#app')